import { render, staticRenderFns } from "./percentChart.vue?vue&type=template&id=74ba72c5&scoped=true&"
import script from "./percentChart.vue?vue&type=script&lang=js&"
export * from "./percentChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ba72c5",
  null
  
)

export default component.exports